import { useFeatureFlags, VariantFlags } from '@/services/feature-flag-provider';
import useSurveyController, { SurveyStatus } from '../shared/use-survey-controller';
import { Status } from './types';

export function usePpraController() {
  const { getVariant } = useFeatureFlags();
  const surveyVersion = getVariant(VariantFlags.PPRAVersion);

  const surveyController = useSurveyController({
    surveyVersion,
  });

  // Map the shared survey status to PPRA status
  const mappedStatus = surveyController.status === SurveyStatus.completed ? Status.completed : Status.ready;

  return {
    ...surveyController,
    status: mappedStatus,
  };
}
